import { useSuspenseQuery } from "../client.ts";

export const useGetSessionSuspenseQuery = () => useSuspenseQuery("get", "/bff/migrate/session");
